import { IS_PRODUCTION, gaTrackingId } from '@fe/common/constants/env'

export const REFERRAL_NAME = 'referral'

const gaId = gaTrackingId

// gtag is absent when the GA snippet is not injected (a brand that runs without
// analytics, or a blocked script) - recording must then be a silent no-op.
const isGaAvailable = () => IS_PRODUCTION && typeof window.gtag === 'function'

export const recordPageview = (path: string) => {
  if (isGaAvailable()) {
    window.gtag('config', gaId, {
      page_path: path,
    })
  }
}

export const rercordEvent = (
  name: Gtag.EventNames,
  params?: Gtag.EventParams
) => {
  if (isGaAvailable()) {
    window.gtag('event', name, params)
  }
}
